<div class="d-flex" style="margin-top:32px">
  <div class="header-btn-lg pe-0">
    <div class="widget-content p-0">
      <div class="widget-content-wrapper">
        <div class="widget-content-left">
          <div class="btn-group" ngbDropdown placement="bottom-right">
            <button type="button" class="btn btn-link p-0 me-2" ngbDropdownToggle>
              <span>
                <div class="icon-wrapper icon-wrapper-alt rounded-circle">
                  <img width="42" src="../../../../../../assets/images/user.jpg" alt="" class="rounded-circle">
                </div>
              </span>
            </button>
            <div ngbDropdownMenu>
            
              <button class="dropdown-item" (click)="openModal(content1)"> <i class="fa fa-user-circle-o" aria-hidden="true"></i> Profile </button>
              <button (click)="logout()" class="dropdown-item text-danger">Logout <i class="fa fa-sign-out text-danger " aria-hidden="true"></i></button>
              <!-- <h6 class="dropdown-header">Header</h6>
              <button class="dropdown-item">Actions</button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item">Dividers</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="card-body">
  <ng-template #content1 let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title"> <i class="fa fa-user-circle-o" aria-hidden="true"></i> Profile   </h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
      </button>
    </div>
    <div class="modal-body">
      
      <div class="row">
        <div class="col-md-12">
          <label for="">Name</label>
          <input type="text" [(ngModel)]="adminName"  placeholder="Enter new password" class="form-control">
       </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <label for="">Admin Type</label>
          <input type="text" [(ngModel)]="adminType"  placeholder="Enter new password" class="form-control" [disabled]="true">
       </div>
      </div>


      <div class="row">
          <div class="col-md-12">
            <label for="">New Password</label>
            <input type="text" [(ngModel)]="newPassword"  placeholder="Enter new password" class="form-control">
         </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label for="">Confirm Password</label>
            <input type="text" [(ngModel)]="confirmPassword"  placeholder="Enter confirm password" class="form-control">
         </div>
        </div>
        
        <div class="row mt-2 mb-2 text-center">
         <div class="col-md-12">
           <button (click)="update()" [disabled]=" adminName == '' || adminType == ''" class="btn btn-primary btn-lg btn-block">Update Profile</button>
         </div>
       </div>

    </div>
    <!-- <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
      <button type="button" class="btn btn-primary">Save changes</button>
    </div> -->
  </ng-template>
  <!-- <button class="btn btn-primary" (click)="open(content5)">Launch demo modal</button> -->
</div>